import { createContext, useState, useContext, useCallback } from 'react'
import { Notification, NotificationType } from '../components/Notification'

type NotificationContextType = {
  showNotification: (_notification: NotificationType) => void
  hideNotification: () => void
  replaceNotification: (_notification: NotificationType) => void
}

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined
)

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [notification, setNotification] = useState<
    NotificationType | undefined
  >(undefined)

  const showNotification = useCallback((notification: NotificationType) => {

    setNotification(notification)
  }, [])

  const hideNotification = useCallback(() => {
    setNotification(undefined)
  }, [])

  const replaceNotification = useCallback((newNotification: NotificationType) => {
    // Directly replace notification to avoid race conditions
    setNotification(newNotification)
  }, [])

  return (
    <NotificationContext.Provider
      value={{ showNotification, hideNotification, replaceNotification }}
    >
      {children}
      <Notification notification={notification} onClose={hideNotification} />
    </NotificationContext.Provider>
  )
}

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (context === undefined) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    )
  }
  return context
}
